import * as T from 'prop-types';

import { Box, Flex, Text } from '@olist/united';

const PersonalInformationWrapper = ({ children, description, stepLabel, title }) => {
  return (
    <Flex flex={1} mt={5} flexDirection="column">
      <Box mb={5}>
        <Text data-testid="stepLabel" color="foundation.shadeDark">
          {stepLabel}
        </Text>
        <Text.H3 data-testid="title" fontWeight="bold" fontSize={[4, 5]}>
          {title}
        </Text.H3>
        {description && (
          <Text data-testid="description" fontSize={[2, 2, 3]} mt={3} color="foundation.shadeDark">
            {description}
          </Text>
        )}
      </Box>
      {children}
    </Flex>
  );
};

PersonalInformationWrapper.defaultProps = {
  description: undefined,
};

PersonalInformationWrapper.propTypes = {
  stepLabel: T.string.isRequired,
  title: T.string.isRequired,
  description: T.string,
  children: T.node.isRequired,
};

export default PersonalInformationWrapper;
